import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { ParametroIntegracaoUberForm } from "./components/ParametroIntegracaoUberForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Uber" />
            <Loading />
            <ParametroIntegracaoUberForm />
        </>
    )
}
